import { Campaign } from "./campaign";

export class Agent {
    id!: string;
    name!: string;
    email!: string;
    phoneNumber!: string;
    birthDate!: Date;

    campaignCount!: number;
    campaigns!: Campaign[];
}
